export default class ValidationService {

    static setError(target, key, message) {

        console.log(JSON.parse(JSON.stringify(target)))

        let _data = {};

        _data[key] = message;

        return _data;
    }
}